<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div style="padding:50px 250px 50px 50px;" class="cs-fullHeight">
        <div class="text-center backgroud-white cs-fullHeight main-content-container">
          <div class="image-container">
            <img src="../assets/warning.png">
          </div>
          <div class="content-container">
            <el-row>
              <el-col class="content-container-description">
                <span>我们需要验证您的邮箱真实性，以便之后发送一些教学资料，请填写您的个人邮箱并发送验证码进行验证，谢谢您的配合</span>
                <span>（最好是用gmail哦，不然可能会收不到资料，没有gmail的亲亲可以先注册一下，然后再来验证哈~~）</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div class="emailValidation-container">
                  <email-editor :type="1" :email="USERMANAGER.studentEmail" @saveSuccess="onEmailEditorSaveSuccess" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { isStudentEmailValidated } from "@/service/student.service";

export default {
  name: "studentEmailValidation",
  components: {
    emailEditor: () => import("@/components/emailEditor"),
  },
  data() {
    return {
      isEmailValidated: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async loadStudentEmailValidatedFromServer() {
      try {
        let studentId = this.USERMANAGER.studentId;
        let result = await isStudentEmailValidated(studentId);
        if (!!result && result.success) {
          this.USERMANAGER.studentIsEmailValidated = this.isEmailValidated =
            result.data;
        }
      } catch (error) {
        this.error(error);
      }
    },

    async init() {
      this.isEmailValidated = this.USERMANAGER.studentIsEmailValidated;
      if (!this.isEmailValidated)
        await this.loadStudentEmailValidatedFromServer();

      if (this.isEmailValidated) {
        this.$message.success("邮箱已通过验证");

        setTimeout(() => {
          this.onEmailEditorSaveSuccess();
        }, 1000);
      }
    },
    onEmailEditorSaveSuccess() {
      this.$router.push({
        path: "/studentLanding",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-main-right-container {
  min-height: 650px !important;

  .main-content-container {
    padding-top: 40px;

    .image-container {
    }

    .content-container {
      .el-row {
        margin-top: 20px;
      }

      .content-container-description{
        padding: 0 50px;
        span{
          display: block;
        }
      }

      .emailValidation-container {
        width: 60%;
        height: 300px;
        margin: 0 auto;

        /deep/ .popup-content-area-small {
          min-height: auto;

          &.backgroud-gray-popup {
            background-color: transparent;
          }
        }
      }
    }
  }
}

.cs-fullHeight {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/studentEmailValidation.vue